import { useEffect, useState } from 'react'
import Uploadfiles from '../../../../modules/uploadfiles'
import { FINANCIAL_INVOICE_FILE_TYPE } from '../..'
import { Button, Space } from 'antd'
import { fileFile } from '../../../../modules/uploadfiles/hooks'

interface Props {
  value?: fileFile[]
  onChange?: (e: fileFile[]) => void
  handleRecognize?: (file?: fileFile[]) => void
}

const UploadSingleInvoice = (props: Props) => {
  const { value, onChange, handleRecognize } = props

  const [recognizable, setRecognizable] = useState<boolean>(false)

  useEffect(() => {
    if (value) {
      setRecognizable(value.length > 0)
    }
  }, [value])

  const onRecognize = () => {
    handleRecognize?.(value)
  }

  return (
    <Space size={16} align="start">
      <Uploadfiles
        title="选择文件"
        type="invoice"
        accept={FINANCIAL_INVOICE_FILE_TYPE}
        maxCount={1}
        directlyDelete
        dataSource={value}
        onChange={onChange}
      />
      {recognizable && (
        <Button type="link" onClick={onRecognize}>
          识别附件信息
        </Button>
      )}
    </Space>
  )
}

export default UploadSingleInvoice
import { useEffect, useState } from 'react'
import Uploadfiles from '../../../../modules/uploadfiles'
import { FINANCIAL_INVOICE_FILE_TYPE } from '../..'
import { Button, Space } from 'antd'
import { fileFile } from '../../../../modules/uploadfiles/hooks'

interface Props {
  value?: fileFile[]
  onChange?: (e: fileFile[]) => void
  handleRecognize?: (file?: fileFile[]) => void
}

const UploadSingleInvoice = (props: Props) => {
  const { value, onChange, handleRecognize } = props

  const [recognizable, setRecognizable] = useState<boolean>(false)

  useEffect(() => {
    if (value) {
      setRecognizable(value.length > 0)
    }
  }, [value])

  const onRecognize = () => {
    handleRecognize?.(value)
  }

  return (
    <Space size={16} align="start">
      <Uploadfiles
        title="选择文件"
        type="invoice"
        accept={FINANCIAL_INVOICE_FILE_TYPE}
        maxCount={1}
        directlyDelete
        dataSource={value}
        onChange={onChange}
      />
      {recognizable && (
        <Button type="link" onClick={onRecognize}>
          识别附件信息
        </Button>
      )}
    </Space>
  )
}

export default UploadSingleInvoice
